__turbopack_context__.v({
  "card": "q9vX7a_card",
  "container": "q9vX7a_container",
  "containerList": "q9vX7a_containerList",
  "list": "q9vX7a_list",
  "navigation": "q9vX7a_navigation",
});
